import { IStepGeometry, IVec3 } from '@stair-craft/common/util';

export function buildFlightSawtoothZ(
    steps: IStepGeometry[],
    x: number,
    entryY: number,
    exitY: number,
    exitZ: number,
    direction: 1 | -1
): IVec3[] {
    const first: IStepGeometry = steps[0];
    const points: IVec3[] = [{ x, y: entryY, z: first.position.z }];
    for (const step of steps) {
        const zFront: number = step.position.z;
        const zBack: number = step.position.z + direction * step.treadDepth;
        points.push({ x, y: step.position.y, z: zFront });
        points.push({ x, y: step.position.y, z: zBack });
    }
    points.push({ x, y: exitY, z: exitZ });
    return points;
}
